import { render } from "./my_linktones.vue?vue&type=template&id=06bee20f"
import script from "./my_linktones.vue?vue&type=script&lang=js"
export * from "./my_linktones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__